import React from 'react'

const Header = () => {
    return (
        <div className="heading">
            <h1 className="heading-title">
                <img src="https://www.romaincousin.fr/2048/img/2048-animated-edition.gif" alt="2048 - Animated edition" />
            </h1>
        </div>
    )
}

export default Header
